import { createCRUDHook } from './createCRUDHook';
import { ProcessProductionStationDto } from 'utils/models';
import { PRODUCTION_PROCESS_STATION } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<ProcessProductionStationDto>({
    entityName: 'ProductionProcessStation',
    endpoint: PRODUCTION_PROCESS_STATION,
  });

export const ProcessProductionStationContext = Context;
export const useProductionProcessStationManager = useManager;
export const useProductionProcessStation = useConsumer;
